<template>
    <div>
        <h1 class="display-heading">E-Wallet Application</h1>

        <div>
            <div class="row mb-3">
                <div class="col-md-3"><b>Clinic Name</b></div>
                <div class="col-md-9">
                    {{ clinicName }}
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3"><b>Applicant Name</b></div>
                <div class="col-md-9">
                    {{ applicantName }}
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3"><b>Submission Date</b></div>
                <div class="col-md-9">
                    {{ addedAt }}
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3"><b>Last Updated</b></div>
                <div class="col-md-9">
                    {{ updatedAt }}
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3"><b>Type</b></div>
                <div class="col-md-9">
                    {{ getCompanyTypeName }}
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3"><b>Forms</b></div>
                <div class="col-md-9">
                    <button class="btn btn-primary btn-primary-insv mr-2 mb-2" @click="downloadDocument">
                            Download Documents
                    </button>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3"><b>Processed Status</b></div>
                <div class="col-md-9">
                    <span
                        class="badge text-nowrap"
                        :class="{
                            'badge-success': isProcessed,
                            'badge-secondary': !isProcessed,
                        }"
                    >
                        {{ isProcessed ? "Processed" : "Not Processed Yet" }}
                    </span>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3"><b>Approval Status</b></div>
                <div class="col-md-9">
                    <template v-if="isProcessed && (isApproved || isDisapproved)">
                        <span
                            class="badge text-nowrap"
                            :class="{
                                'badge-success': isApproved,
                                'badge-danger': isDisapproved,
                            }"
                        >
                            {{
                                isApproved
                                    ? "Approved"
                                    : "Disapproved"
                            }}
                        </span>
                    </template>
                    <template v-else>
                        Pending
                    </template>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3"><b>Update Status</b></div>
                <div class="col-md-9">
                    <button
                        v-if="!isProcessed"
                        class="btn btn-primary btn-primary-insv mr-2"
                        @click="updateToProcessed"
                    >
                        Update to Processed
                    </button>

                    <template v-if="isProcessed">
                        <button
                            class="btn btn-primary btn-primary-insv mr-2"
                            @click="updateToApproved"
                        >
                            Approve
                        </button>
                        <button
                            class="btn btn-primary btn-danger mr-2"
                            @click="updateToDisapproved"
                        >
                            Disapprove
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { convertToUserReadableDateTime } from '@/utilities';
import { apiPath } from '@/config';
import eWalletApplicationTypes from '@/config/eWalletApplicationTypes';
export default {
    'computed': {
        applicationId () {
            return this.$route.params.applicationId;
        },
        downloadApplicationUrl () {
            return this.applicationId
                ? `${apiPath}EWalletApplication/DownloadApplication?applicationId=${this.applicationId}`
                : null;
        },
        getCompanyTypeName () {
            if (parseInt(this.companyType) === eWalletApplicationTypes.SdnBhd) {
                return 'Sdn Bhd';
            } else if (parseInt(this.companyType) === eWalletApplicationTypes.SolePartnerLlp) {
                return 'Sole Prop / Partnership / LLP';
            } else if (parseInt(this.companyType) === eWalletApplicationTypes.NewCompaniesAct) {
                return 'New Companies Act';
            }
        }
    },
    data () {
        return {
            'clinicName': null,
            'applicantName': null,
            'addedAt': null,
            'updatedAt': null,
            'applicationStatus': null,
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': '',
            'isProcessed': false,
            'isApproved': false,
            'isDisapproved': false,
            'companyType': 0
        };
    },
    mounted () {
        this.getApplication();
    },
    'methods': {
        validateForm () {
            return this.$validator.validateAll();
        },
        getApplication () {
            this.axios
                .get('EWalletApplication/Get', {
                    'params': {
                        'applicationId': this.applicationId
                    }
                })
                .then(({ data }) => {
                    let application = data.data;

                    if (application) {
                        this.clinicName = application.cn;
                        this.applicantName = application.an;
                        this.addedAt = application.aa
                            ? convertToUserReadableDateTime(application.aa)
                            : '-';
                        this.updatedAt = application.ua
                            ? convertToUserReadableDateTime(application.ua)
                            : '-';
                        this.isProcessed = application.ip;
                        this.isApproved = application.ia;
                        this.isDisapproved = application.id;
                        this.companyType = application.t;
                    }
                });
        },
        updateToProcessed () {
            this.axios
                .post('EWalletApplication/Process', {
                    'aid': this.applicationId
                })
                .then(() => {
                    this.getApplication();
                });
        },
        updateToApproved () {
            this.axios
                .post('EWalletApplication/Approve', {
                    'aid': this.applicationId
                })
                .then(() => {
                    this.getApplication();
                });
        },
        updateToDisapproved () {
            this.axios
                .post('EWalletApplication/Disapprove', {
                    'aid': this.applicationId
                })
                .then(() => {
                    this.getApplication();
                });
        },
        downloadDocument () {
            window.open(`${apiPath}EWalletApplication/DownloadApplication?applicationId=${this.applicationId}`);
        },
        getDocumentTypeName (type) {
            switch (type) {
            case 0:
                return 'M & A';
            case 1:
                return 'Form 9';
            case 2:
                return 'Form 24';
            case 3:
                return 'Form 44';
            case 4:
                return 'Form 49';
            case 5:
                return 'SSM / LLP';
            case 6:
                return 'Section 14';
            case 7:
                return 'Section 15';
            case 8:
                return 'Section 17';
            case 9:
                return 'Section 48';
            case 10:
                return 'Section 236';
            case 11:
                return 'IC';
            case 12:
                return 'Company Bank Statements';
            case 13:
                return 'Shop Photos';
            case 14:
                return 'Company Write Up';
            case 15:
                return 'Application Form';
            }
        }
    }
};
</script>
